/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EquipementDto } from '../../models/equipement-dto';

export interface GetEquipementsByQrCode$Params {
  qr_code: string;
}

export function getEquipementsByQrCode(
  http: HttpClient,
  rootUrl: string,
  params: GetEquipementsByQrCode$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<EquipementDto>> {
  const rb = new RequestBuilder(rootUrl, getEquipementsByQrCode.PATH, 'get');
  if (params) {
    rb.query('qr_code', params.qr_code, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EquipementDto>;
    })
  );
}

getEquipementsByQrCode.PATH = '/v1/equipements/byQrCode';
